export default __webpack_public_path__ + "static/media/5.87c0b5e2.jpg";